<template>
  <div class="list">
    <el-card  class="box-card">
      <el-row :gutter="20">
        <el-col :span="16">
          <div class="card_tit"><span v-if="article.is_top" style="color: red;">[顶]</span>{{article.title}}</div>
          <div class="card_desc">{{article.describe}}</div>
        </el-col>
        <el-col :span="8">
               <img
                style="max-width: 100%; max-height: 100px"
                :src="article.img_url" alt="">
          <div class="read_num">阅读量：{{article.num}}</div>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
  export default{
    name:'ArticleList',
    props:{
      article:{
        type:Object,
        default(){
          return {}
        }
      },
    },
    mounted() {
    }
  }
</script>

<style lang="scss">
  .list{
   .el-card__body{
      .card_tit{
        margin: 0 0 30px 0;
        text-align: left;
        color: #000000;
        // color: #409EFF;
        font-size: 20px;
        font-weight: 700;
      }
      .card_desc{
        margin-top: 30px;
        text-align: left;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ArticleList.vue